import type { ReactNode } from "react"
import { greetUser } from "@/lib/greeting"

interface HomeGreetingProps {
  /** The user's full name; the greeting uses the first word, or no name at all. */
  fullName: string | null | undefined
  /** Injectable clock; defaults to the current (local) time. */
  now?: Date
  /** Right-hand action, e.g. the New bid button. */
  action?: ReactNode
}

// Home's page header: a time-of-day greeting, today's date, and the one
// primary action on the page.
export function HomeGreeting({ fullName, now = new Date(), action }: HomeGreetingProps) {
  const date = now.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" })

  return (
    <div className="flex items-end justify-between gap-4" data-testid="home-greeting">
      <div className="min-w-0">
        <h1 className="truncate text-lg font-medium">
          {greetUser(fullName, now)}
        </h1>
        <p className="text-meta mt-0.5">{date}</p>
      </div>
      {action}
    </div>
  )
}
